import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import "./CategoryProfileCard.styles.scss";

const CategoryProfileCard: FCX = ({ children, className, testId }) => (
    <div className={cn("CategoryProfileCard", className)} data-testid={testId}>
        {children}
    </div>
);

export default CategoryProfileCard;
